import { ApiResponse } from "@roc/feature-app-core";
import { InsuranceAgentService } from "./insuranceAgentService";

export class InsuranceAgentInternalService extends InsuranceAgentService {
  getInsuranceAgentGrid(zipCode: string, page: number, pageSize: number, sortDir: string, sortBy: string, filters: object): Promise<ApiResponse> {
    return this.get('nportal/rest/priv/insurance/getInsuranceAgents', { zipCode, page, pageSize, sortDir, sortBy, filters });
  }
}